var _rect, _rect2, _rect3, _g, _use, _g2, _use2, _path, _path2, _path3, _path4, _path5, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _g3, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _ellipse11, _ellipse12, _g4, _path13, _path14, _path15, _path16, _path17, _rect4, _rect5, _rect6, _rect7, _rect8, _ellipse13, _path18, _path19, _ellipse14, _ellipse15, _ellipse16, _ellipse17, _ellipse18, _ellipse19, _path20, _ellipse20, _rect9, _path21, _path22, _path23, _path24, _path25, _rect10, _rect11, _rect12, _rect13, _rect14;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1200 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Flag of Oman") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    fill: "#db161b",
    height: 600
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    height: 200,
    width: 900,
    x: 300,
    fill: "#fff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    height: 200,
    width: 900,
    y: 400,
    x: 300,
    fill: "#008000"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a",
    fillRule: "evenodd",
    stroke: "#db161b",
    strokeWidth: "0.26422498pt",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    rx: 3.2154,
    ry: 3.0152,
    height: 21.217,
    width: 38.669,
    y: 102.64,
    x: 65.854,
    strokeWidth: "0.28333pt"
  }), /*#__PURE__*/React.createElement("rect", {
    rx: 3.0505,
    ry: 2.764,
    height: 19.449,
    width: 36.686,
    y: 103.52,
    x: 66.846,
    strokeWidth: "0.26422pt"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.904,108.83l1.853,0.06,0.084,0.84,1.516,0.77,1.18-0.96,1.431,0.77-1.347,0.84,0.337,1.16,1.684-0.06v1.55l-1.347-0.07-0.674,0.97,1.516,1.1-1.179,0.9-1.264-0.97-1.853,0.39,0.084,1.42-2.021,0.13-0.253-1.36-1.684-0.71-0.927,0.97-1.432-0.71,0.843-1.1-1.011-0.71h-1.432l-0.084-2,1.432,0.13,1.01-1.16-1.179-0.9,1.516-1.04,1.095,0.84,1.853-0.25,0.253-0.84z",
    strokeWidth: "0.16681166pt"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 68.944,
    cy: 426.78,
    rx: 11.049,
    ry: 9.9439,
    transform: "matrix(0.1841806,0,0,0.1752043,71.76647,38.246478)",
    strokeWidth: "1pt"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.803,104.41l-2.974,2.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.786,104.41l-2.974,2.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.769,104.41l-2.974,2.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.752,104.41l-2.974,2.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.735,104.41l-2.974,2.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.718,104.41l-2.974,2.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.702,104.41l-2.975,2.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.685,104.41l-2.975,2.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.668,104.41l-2.975,2.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.651,104.41l-2.975,2.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.634,104.41l-2.975,2.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.617,104.41l-2.975,2.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.685,104.41l-2.975,2.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.6,104.41l-2.975,2.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.583,104.41l-2.975,2.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.566,104.41l-2.975,2.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.55,104.41l-2.976,2.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.574,104.41l2.976,2.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.591,104.41l2.975,2.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.608,104.41l2.975,2.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.625,104.41l2.975,2.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.642,104.41l2.975,2.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.659,104.41l2.975,2.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.676,104.41l2.975,2.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.693,104.41l2.975,2.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.71,104.41l2.975,2.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.727,104.41l2.975,2.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.744,104.41l2.975,2.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.761,104.41l2.974,2.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.693,104.41l2.975,2.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.778,104.41l2.974,2.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.795,104.41l2.974,2.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.812,104.41l2.974,2.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.829,104.41l2.974,2.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.803,119.43l-2.974,2.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.786,119.43l-2.974,2.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.769,119.43l-2.974,2.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.752,119.43l-2.974,2.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.735,119.43l-2.974,2.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.718,119.43l-2.974,2.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.702,119.43l-2.975,2.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.685,119.43l-2.975,2.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.668,119.43l-2.975,2.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.651,119.43l-2.975,2.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.634,119.43l-2.975,2.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.617,119.43l-2.975,2.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.685,119.43l-2.975,2.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.6,119.43l-2.975,2.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.583,119.43l-2.975,2.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.566,119.43l-2.975,2.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.55,119.43l-2.976,2.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.574,119.43l2.976,2.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.591,119.43l2.975,2.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.608,119.43l2.975,2.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.625,119.43l2.975,2.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.642,119.43l2.975,2.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.659,119.43l2.975,2.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.676,119.43l2.975,2.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.693,119.43l2.975,2.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.71,119.43l2.975,2.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.727,119.43l2.975,2.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.744,119.43l2.975,2.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.761,119.43l2.974,2.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.693,119.43l2.975,2.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.778,119.43l2.974,2.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.795,119.43l2.974,2.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.812,119.43l2.974,2.66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.829,119.43l2.974,2.66"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    x: -300,
    transform: "scale(-1,1)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.51,147.12c-48.114,47.05-68.638,53-59.006,56.79s40.616-20.49,72.856-52.75c32.24-32.25,51.98-60.956,42.35-64.747-9.63-3.792-5.03,10.662-56.2,60.707z",
    fillRule: "evenodd",
    stroke: "#db161b",
    strokeWidth: "0.42368097pt",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.008,181.31l16.852,4.42c-15.861,15.03-33.708,21.22-38.665,18.57-4.958-2.65,8.923-8.84,21.813-22.99z",
    fillRule: "evenodd",
    stroke: "#db161b",
    strokeWidth: 0.33028123,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.008,183.08l13.881,3.54c-15.453,14.45-30.737,18.56-34.692,16.8-3.977-1.77,8.255-6.74,20.811-20.34z",
    fillRule: "evenodd",
    stroke: "#db161b",
    strokeWidth: 0.33028045,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.79,145.06c-0.04,0.23-0.15,1.24-0.25,1.64,0,0.56-0.06,0.98-0.12,1.42-0.16,0.38-0.13,0.73-0.62,0.87-0.33,0.46-0.54,0.58-0.98,0.77-0.3,0.23-0.76,0.46-1.24,0.65-0.49,0.19-0.94,0.21-1.47,0.11-0.44-0.27-0.75-0.54-1.11-0.76-0.09-0.35-0.16-0.86-0.25-1.2,0.13,0.35,0.23,0.91,0.25,1.41-0.05,0.55-0.25,0.79-0.49,1.2",
    stroke: "#db161b",
    strokeWidth: 0.33028081,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.23,152.37c-0.04-0.03-0.08-0.07-0.12-0.11,0.29,0.26,0.17,0.14-0.5-0.21-0.47-0.22-0.98-0.34-1.6-0.44h-1.72c-0.67,0-1.12,0.09-1.6,0.22-0.35,0.31-0.87,0.48-1.23,0.76-0.38,0.23-0.54,0.5-0.74,0.87-0.34,0.3-0.56,0.76-0.87,0.99-0.13,0.5-0.42,0.48-0.61,0.87,0.58,0.04,1.05,0.11,1.35,0.43,0.52,0.24-0.43-0.23-0.61-0.43-0.41-0.11-0.51-0.22-1.11-0.22-0.56-0.16-0.9,0.13-1.48,0.22-0.33,0.17-0.43,0.22-0.86,0.22",
    stroke: "#db161b",
    strokeWidth: 0.33028081,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.58,157.83c-0.25,0.01-1.4,0.2-1.85,0-0.5-0.12-0.8-0.36-1.11-0.77-0.15-0.29,0,0.53,0,0.88-0.05,0.64-0.27,0.65-0.61,1.09-0.36,0.2-0.74,0.49-1.11,0.65-0.31,0.24-0.69,0.4-1.11,0.55-0.37,0.15-0.81,0.31-1.11,0.54-0.41,0.26-0.37,0.58-0.61,0.98,0.04,0.54,0.14,0.84,0.49,1.1,0.14,0.36,0.47,0.73,0.74,0.98,0.3,0.5,0.64,0.73-0.13,0.87-0.42,0.16-0.65,0.03-1.1,0",
    stroke: "#db161b",
    strokeWidth: 0.33028081,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.82,165.46c-0.3-0.06-1.38-0.38-1.85-0.54h-1.72c-0.67,0.04-0.8,0.22-1.36,0.43-0.36,0.33-0.61,0.56-1.11,0.77-0.26,0.3-0.78,0.81-0.98,1.2-0.15,0.37-0.25,0.87-0.25,1.42,0.01,0.63,0.2,0.74,0.25,1.31,0.14,0.46,0.36,0.89,0.74,1.3,0.05,0.14,0.09,0.18,0.24,0.22",
    stroke: "#db161b",
    strokeWidth: 0.33028081,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.95,173c-0.05,0-0.17,0.28-0.35,0.52-0.39,0.4-0.44,0.43-1.05,0.43-0.54-0.02-0.49-0.21-0.87-0.35-0.18-0.27-0.41-0.49-0.61-0.86-0.14-0.22-0.27-0.57-0.44-0.77-0.16-0.26-0.36-0.45-0.53-0.69-0.16-0.07-0.22-0.14-0.43-0.17,0.5,0.08,0.54,0.25,0.87,0.51,0.15,0.25,0.31,0.5,0.44,0.78,0.05,0.37,0.17,0.66,0.17,1.12,0,0.47,0,0.81-0.17,1.2-0.21,0.22-0.36,0.44-0.61,0.61-0.21,0.19-0.46,0.45-0.62,0.68-0.27,0.17-0.47,0.31-0.78,0.52-0.27,0.15-0.55,0.31-0.96,0.35-0.52-0.04-0.67-0.18-1.05-0.35-0.33-0.24-0.59-0.39-0.88-0.6-0.23-0.16-0.46-0.47-0.61-0.69-0.47-0.12-0.77-0.07-1.05,0.17-0.24,0.16-0.45,0.37-0.61,0.6-0.15,0.07-0.38,0.28-0.53,0.35",
    stroke: "#db161b",
    strokeWidth: 0.33028191,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.32,176.56c0.14,0.06,0.64,0.41,0.87,0.54,0.14,0.45,0.36,0.7,0.43,1.18,0.12,0.47,0.11,0.98,0.11,1.51-0.12,0.55-0.35,0.95-0.54,1.39-0.35,0.24-0.52,0.4-0.98,0.65-0.43,0.06-0.86,0.11-1.41,0.11-0.34,0.11-0.98,0.16-1.31,0-0.48-0.07-0.843-0.26-1.194-0.43-0.402-0.23-0.649-0.44-1.088-0.65-0.213-0.31-0.544-0.59-0.869-0.97-0.271-0.36-0.47-0.56-0.653-0.96,0.161,0.46,0.405,0.86,0.544,1.29,0.247,0.45,0.391,0.62,0.435,1.18,0.151,0.45,0.109,0.99,0.109,1.5-0.048,0.35-0.073,1.01-0.218,1.29v0.33",
    stroke: "#db161b",
    strokeWidth: 0.33028162,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.242,186.23v0.16c0-0.42-0.011-0.21,0.175,0.62,0.33,0.37,1.104,0.47,1.749,0.31,0.566-0.41,0.548-0.73,1.574-0.93,0.991,0.06,1.369,0.32,1.924,0.62,0.658,0.29,0.962,0.44,1.399,1.09,0.217,0.53,0.338,0.89-0.35,1.09-0.547,0.35-1.197,0.54-1.924,0.63-0.808,0-1.39-0.09-1.749,0.31-0.555,0.51-0.524,0.82-0.524,1.71-0.187,0.28-0.224,1.1-0.35,1.41-0.486,0.2-0.771,0.31-1.574,0.31-0.189-0.48-0.398-1.35-0.525-1.87-0.137-0.56-0.179-1.34-0.525-1.72-0.326-0.42-0.743-0.8-1.224-1.09-0.214-0.27-0.622-0.49-1.049-0.62,0.686,0.31,0.784,0.65,0.874,1.4-0.603,0.27-0.764,0.46-1.749,0.47-0.968-0.07-1.202-0.29-1.574-0.78-0.067,0.78-0.348,1.04-0.524,1.72-0.36,0.47-0.513,0.95-0.875,1.55,0.154,0.76,0.486,0.79,0.525,1.72,0.227,0.61,0.202,1.19,0.699,1.56,0.222,0.24,0.388,0.29,0.875,0.31-1.013,0-1.603-0.1-2.274-0.47-0.519-0.28-0.911-0.64-1.399-0.93-0.619-0.4-1.384-0.77-2.099-0.94-0.808,0-1.39-0.08-1.749,0.31-0.495,0.32-0.828,0.86-1.049,1.56-0.162,0.81-0.224,1.35,0.175,1.87,0.296,0.61,0.363,0.84,0,1.56-0.407,0.51-1.012,0.57-1.924,0.78-0.666-0.03-1.306-0.16-1.749-0.31",
    stroke: "#db161b",
    strokeWidth: 0.33028123,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.41,104.66c21.35-36.858,35.52-68.222,31.62-70.014-3.89-1.791-24.37,26.665-45.72,63.518l14.1,6.496z",
    fillRule: "evenodd",
    stroke: "#db161b",
    strokeWidth: "0.33520904pt",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180,104.01c20.59-35.557,34.78-65.574,31.67-67.007s-22.35,26.258-42.95,61.81",
    fillRule: "evenodd",
    stroke: "#db161b",
    strokeWidth: "0.29448283pt",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.46,85.461c-2.51,4.157-5.16,8.908-7.74,13.352l11.28,5.197c2.57-4.448,5.38-9.13,7.73-13.356l-11.27-5.193z",
    fillRule: "evenodd",
    stroke: "#db161b",
    strokeWidth: "0.33422136pt",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.41,86.895c-2.5,4.157-4.25,7.338-6.82,11.782l8.45,3.893c2.58-4.442,4.48-7.554,6.83-11.78l-8.46-3.895z",
    fillRule: "evenodd",
    stroke: "#db161b",
    strokeWidth: "0.33422136pt",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(-0.9083207,-0.4182743,-0.5012544,0.8653,0,0)",
    height: 9.9849,
    width: 6.2072,
    stroke: "#db161b",
    y: 6.5585,
    x: -205.69,
    strokeWidth: "0.33495pt",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.55,91.712l-10.64,6.043",
    fillRule: "evenodd",
    stroke: "#db161b",
    strokeWidth: "0.33422136pt",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.54,100.35l-0.63-11.235",
    fillRule: "evenodd",
    stroke: "#db161b",
    strokeWidth: "0.33422136pt",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.03,47.727l-5.64-2.597",
    fillRule: "evenodd",
    stroke: "#db161b",
    strokeWidth: "0.33422136pt",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.5433,
    ry: 3.5433,
    stroke: "#db161b",
    transform: "matrix(-0.4490005,0.1132067,0.1013394,0.3938715,444.34717,-55.797864)",
    cy: 92.126,
    cx: 545.67,
    strokeWidth: "1pt",
    fill: "#db161b"
  }))), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    x: -300,
    transform: "scale(-1,1)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M135.26,84.958c0,30.942,0.18,42.602-2.1,44.202-2.16,1.71-62.348,0-62.348,8.84s49.578,17.68,64.448,17.68c19.83,0,29.75-8.84,29.75-26.52v-44.202h-29.75z",
    fillRule: "evenodd",
    stroke: "#db161b",
    strokeWidth: "0.30510197pt",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M135.26,93.798v4.42c9.92,1.474,19.83,1.474,29.75,0v-4.42c-9.92,1.474-19.83,1.474-29.75,0z",
    fillRule: "evenodd",
    stroke: "#db161b",
    strokeWidth: "0.26422367pt",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M135.26,84.958v4.42c9.92,1.473,19.83,1.473,29.75,0v-4.42c-9.92,1.473-19.83,1.473-29.75,0z",
    fillRule: "evenodd",
    stroke: "#db161b",
    strokeWidth: "0.26422367pt",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M135.26,89.378v4.42c9.92,1.474,19.83,1.474,29.75,0v-4.42c-9.92,1.473-19.83,1.473-29.75,0z",
    fillRule: "evenodd",
    stroke: "#db161b",
    strokeWidth: "0.26422367pt",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M135.26,98.218v4.422c9.92,1.47,19.83,1.47,29.75,0v-4.422c-9.92,1.474-19.83,1.474-29.75,0z",
    fillRule: "evenodd",
    stroke: "#db161b",
    strokeWidth: "0.26422367pt",
    fill: "#fff"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    rx: 8.8583,
    ry: 26.575,
    stroke: "#db161b",
    transform: "matrix(0.1526333,0,0,3.5883686e-2,97.402506,84.325604)",
    cy: 210.83,
    cx: 256.89,
    strokeWidth: 4.4628,
    fill: "#fff"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 8.8583,
    ry: 26.575,
    stroke: "#db161b",
    transform: "matrix(0.1526333,0,0,3.5883686e-2,97.40259,83.530922)",
    cy: 246.26,
    cx: 292.32,
    strokeWidth: 4.4628,
    fill: "#fff"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 8.8583,
    ry: 26.575,
    stroke: "#db161b",
    transform: "matrix(0.1526333,0,0,3.5883436e-2,97.40259,83.372046)",
    cy: 263.98,
    cx: 327.76,
    strokeWidth: 4.4629,
    fill: "#fff"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 8.8583,
    ry: 26.575,
    stroke: "#db161b",
    transform: "matrix(0.1526333,0,0,3.5883436e-2,97.40259,83.372046)",
    cy: 263.98,
    cx: 363.19,
    strokeWidth: 4.4629,
    fill: "#fff"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 8.8583,
    ry: 26.575,
    stroke: "#db161b",
    transform: "matrix(0.1526333,0,0,3.5883686e-2,97.40259,83.530922)",
    cy: 246.26,
    cx: 398.62,
    strokeWidth: 4.4628,
    fill: "#fff"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 8.8583,
    ry: 26.575,
    stroke: "#db161b",
    transform: "matrix(0.1526333,0,0,3.5883686e-2,97.402534,84.325604)",
    cy: 210.83,
    cx: 434.06,
    strokeWidth: 4.4628,
    fill: "#fff"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    stroke: "#db161b",
    strokeWidth: "0.26422498pt",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.26,107.06l29.75,23.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.23,107.06l26.78,21.21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.2,107.94l22.81,17.68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.18,107.94l19.83,15.03"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.15,107.94l16.86,12.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.12,107.94l13.89,9.73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.1,107.94l10.91,7.07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.07,107.94l7.94,5.31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.05,107.94l4.96,3.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.02,107.94l1.99,1.77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.26,109.71l29.75,23.87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.01,107.06l-32.72,26.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.03,107.06l-28.75,22.98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.07,107.94l-22.81,17.68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.09,107.94l-19.83,15.03"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.12,107.94l-16.86,12.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.14,107.94l-13.88,9.73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.17,107.94l-10.91,7.07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.19,107.94l-7.93,5.31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.22,107.94l-4.96,3.54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.24,107.94l-1.98,1.77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.01,109.71l-32.72,26.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.01,112.36l-32.72,26.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.01,115.01l-32.72,26.53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.01,117.67l-32.72,26.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.01,120.32l-32.72,26.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.01,122.97l-32.72,26.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.01,125.62l-32.72,26.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.01,128.28l-32.72,26.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.01,130.93l-30.74,24.75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.01,133.58l-27.77,22.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.01,137.12l-21.81,17.68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.02,140.65l-17.84,14.15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.04,145.07l-8.92,7.07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.26,112.36l28.75,22.99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.26,115.01l28.75,22.99"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.26,117.67l27.76,22.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.26,120.32l27.76,22.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.26,122.97l26.77,21.22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.27,124.74l26.77,21.22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.27,127.39l24.79,19.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.28,129.16l24.79,19.45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.29,130.93l23.79,18.56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.29,133.58l22.8,17.68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.29,136.23l19.83,15.91"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M135.26,102.64v4.42c9.92,1.47,19.83,1.47,29.75,0v-4.42c-9.92,1.47-19.83,1.47-29.75,0z",
    fillRule: "evenodd",
    stroke: "#db161b",
    strokeWidth: "0.26422367pt",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M132.29,138.88l17.84,14.15",
    fillRule: "evenodd",
    stroke: "#db161b",
    strokeWidth: "0.26422498pt",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M132.29,141.54l15.86,12.37",
    fillRule: "evenodd",
    stroke: "#db161b",
    strokeWidth: "0.26422498pt",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M132.29,144.19l13.88,10.61",
    fillRule: "evenodd",
    stroke: "#db161b",
    strokeWidth: "0.26422498pt",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M132.29,146.84l9.91,7.96",
    fillRule: "evenodd",
    stroke: "#db161b",
    strokeWidth: "0.26422498pt",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M132.29,149.49l7.93,6.19",
    fillRule: "evenodd",
    stroke: "#db161b",
    strokeWidth: "0.26422498pt",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M132.29,152.14l4.95,3.54",
    fillRule: "evenodd",
    stroke: "#db161b",
    strokeWidth: "0.26422498pt",
    fill: "#fff"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 8.8583,
    ry: 26.575,
    stroke: "#db161b",
    transform: "matrix(0.1526333,0,0,3.5883686e-2,97.402506,97.586004)",
    cy: 210.83,
    cx: 256.89,
    strokeWidth: 4.4628,
    fill: "#fff"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 8.8583,
    ry: 26.575,
    stroke: "#db161b",
    transform: "matrix(0.1526333,0,0,3.5883686e-2,97.40259,96.791347)",
    cy: 246.26,
    cx: 292.32,
    strokeWidth: 4.4628,
    fill: "#fff"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 8.8583,
    ry: 26.575,
    stroke: "#db161b",
    transform: "matrix(0.1526333,0,0,3.5883436e-2,97.40259,96.632446)",
    cy: 263.98,
    cx: 327.76,
    strokeWidth: 4.4629,
    fill: "#fff"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 8.8583,
    ry: 26.575,
    stroke: "#db161b",
    transform: "matrix(0.1526333,0,0,3.5883436e-2,97.40259,96.632446)",
    cy: 263.98,
    cx: 363.19,
    strokeWidth: 4.4629,
    fill: "#fff"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 8.8583,
    ry: 26.575,
    stroke: "#db161b",
    transform: "matrix(0.1526333,0,0,3.5883686e-2,97.40259,96.791347)",
    cy: 246.26,
    cx: 398.62,
    strokeWidth: 4.4628,
    fill: "#fff"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 8.8583,
    ry: 26.575,
    stroke: "#db161b",
    transform: "matrix(0.1526333,0,0,3.5883686e-2,97.402534,97.586004)",
    cy: 210.83,
    cx: 434.06,
    strokeWidth: 4.4628,
    fill: "#fff"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    stroke: "#db161b",
    strokeWidth: "0.26422498pt",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.625,148.61l35.695-18.57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.642,147.72l33.708-17.68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.651,145.96l30.739-15.92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.659,144.19l26.771-14.15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.676,142.42l24.784-12.38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.668,139.77l16.852-8.84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.676,138l12.89-7.07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.676,135.35l8.924-4.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.6,149.49l33.71-17.68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.574,150.38l31.726-16.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.55,151.26l29.74-15.91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.52,152.14l24.79-13.26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.49,152.14l21.81-11.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.46,153.03l18.84-9.73"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.44,153.91l14.87-7.95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.4,153.91l11.9-6.19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.37,154.8l7.93-4.42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.34,154.8l4.95-2.66"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M133.28,129.16h-4.96c-1.65,8.84-1.65,17.68,0,26.52h4.96c-1.66-8.84-1.66-17.68,0-26.52z",
    fillRule: "evenodd",
    stroke: "#db161b",
    strokeWidth: "0.26422367pt",
    fill: "#fff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M74.778,141.54l11.898-8.84",
    fillRule: "evenodd",
    stroke: "#db161b",
    strokeWidth: "0.26422498pt",
    fill: "#fff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M74.778,135.35l11.898,10.61",
    fillRule: "evenodd",
    stroke: "#db161b",
    strokeWidth: "0.26422498pt",
    fill: "#fff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M92.625,130.93l-5.949,0.88c-1.322,5.6-1.322,10.31,0,15.91l5.949,1.77c-1.322-5.6-1.322-12.96,0-18.56z",
    fillRule: "evenodd",
    stroke: "#db161b",
    strokeWidth: "0.18807621pt",
    fill: "#fff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M164.97,86.726v-4.457c-4.45,0.037-7.43-2.615-7.43-5.305l-14.85,0.037c0,2.653-2.97,5.305-7.43,5.305v4.42h29.71z",
    fillRule: "evenodd",
    stroke: "#db161b",
    strokeWidth: "0.32342911pt",
    fill: "#fff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    height: 5.3041,
    width: 12.734,
    stroke: "#db161b",
    y: 71.697,
    x: 143.75,
    strokeWidth: "0.27335pt",
    fill: "#fff"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    height: 5.3042,
    width: 10.612,
    stroke: "#db161b",
    y: 66.393,
    x: 144.81,
    strokeWidth: "0.27335pt",
    fill: "#fff"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    height: 5.3042,
    width: 10.612,
    stroke: "#db161b",
    y: 61.089,
    x: 144.81,
    strokeWidth: "0.27335pt",
    fill: "#fff"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    height: 7.0722,
    width: 8.4893,
    stroke: "#db161b",
    y: 54.017,
    x: 145.87,
    strokeWidth: "0.27335pt",
    fill: "#fff"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    height: 6.1882,
    width: 9.2211,
    stroke: "#db161b",
    y: 47.829,
    x: 145.51,
    strokeWidth: "0.28488pt",
    fill: "#fff"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 42.52,
    ry: 33.661,
    stroke: "#db161b",
    transform: "matrix(0.2891558,0,0,0.249492,81.982856,1.8592021)",
    cy: 161.22,
    cx: 237.4,
    strokeWidth: "1pt",
    fill: "#fff"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M156.78,41.64c0,2.319,3.07,6.189,3.07,6.189-2.23,1.52-5.83,2.652-9.22,2.652s-7.62-0.631-9.22-2.652c0,0,3.07-3.87,3.07-6.189,0-2.318-3.07-5.304-3.07-5.304,2.22-1.52,5.83-2.652,9.22-2.652s6.99,1.132,9.22,2.652c0,0-3.07,2.986-3.07,5.304z",
    fillRule: "evenodd",
    stroke: "#db161b",
    strokeWidth: "0.26859274pt",
    fill: "#fff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M154.73,41.64c0,2.319,3.07,7.073,3.07,7.073-2.22,1.52-3.78,1.768-7.17,1.768s-5.57,0.253-7.17-1.768c0,0,3.07-4.754,3.07-7.073,0-2.318-3.07-6.188-3.07-6.188,2.22-1.52,3.78-1.768,7.17-1.768s4.95,0.248,7.17,1.768c0,0-3.07,3.87-3.07,6.188z",
    fillRule: "evenodd",
    stroke: "#db161b",
    strokeWidth: "0.26859274pt",
    fill: "#fff"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 10.63,
    ry: 10.63,
    stroke: "#db161b",
    transform: "matrix(0.2891558,0,0,0.249492,81.982856,0.9751721)",
    cy: 166.54,
    cx: 194.88,
    strokeWidth: "1pt",
    fill: "#fff"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 10.63,
    ry: 10.63,
    stroke: "#db161b",
    transform: "matrix(0.2891558,0,0,0.249492,106.57247,0.9751721)",
    cy: 166.54,
    cx: 194.88,
    strokeWidth: "1pt",
    fill: "#fff"
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 10.63,
    ry: 10.63,
    stroke: "#db161b",
    transform: "matrix(0.2891558,0,0,0.249492,94.277639,0.9751721)",
    cy: 166.54,
    cx: 194.88,
    strokeWidth: "1pt",
    fill: "#fff"
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 10.63,
    ry: 10.63,
    stroke: "#db161b",
    transform: "matrix(0.2891558,0,0,0.249492,94.277639,-7.8650879)",
    cy: 166.54,
    cx: 194.88,
    strokeWidth: "1pt",
    fill: "#fff"
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 10.63,
    ry: 10.63,
    stroke: "#db161b",
    transform: "matrix(0.2994823,0,0,0.249492,83.263631,42.524442)",
    cy: 166.54,
    cx: 194.88,
    strokeWidth: "1pt",
    fill: "#fff"
  })), _ellipse19 || (_ellipse19 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 10.63,
    ry: 10.63,
    stroke: "#db161b",
    transform: "matrix(0.2994823,0,0,0.249492,100.24214,42.524442)",
    cy: 166.54,
    cx: 194.88,
    strokeWidth: "1pt",
    fill: "#fff"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M142.69,77.001h14.85l-7.42,7.957-7.43-7.957z",
    fillRule: "evenodd",
    stroke: "#db161b",
    strokeWidth: "0.27334673pt",
    fill: "#fff"
  })), _ellipse20 || (_ellipse20 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 10.63,
    ry: 10.63,
    stroke: "#db161b",
    transform: "matrix(0.3993101,0,0,0.3326564,72.298311,27.790617)",
    cy: 166.54,
    cx: 194.88,
    strokeWidth: "1pt",
    fill: "#fff"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    rx: 1.2377,
    ry: 0.93811,
    height: 5.3042,
    width: 22.805,
    stroke: "#db161b",
    y: 109.72,
    x: 133.77,
    strokeWidth: 0.33028,
    fill: "#fff"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M163.52,105.3c-2.75,0-4.96,2.06-4.96,4.62v4.02c0,2.56,2.21,4.62,4.96,4.62s4.96-2.06,4.96-4.62v-4.02c0-2.56-2.21-4.62-4.96-4.62zm0,1.77c-1.65,0-2.98,1.65-2.98,3.7v2.33c0,2.05,1.33,3.69,2.98,3.69s2.97-1.64,2.97-3.69v-2.33c0-2.05-1.32-3.7-2.97-3.7z",
    fillRule: "evenodd",
    stroke: "#db161b",
    strokeWidth: 0.33028123,
    fill: "#fff"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M137.74,106.19c-1.65,0-2.97,1.64-2.97,3.69v4.1c0,2.05,1.32,3.7,2.97,3.7s2.97-1.65,2.97-3.7v-4.1c0-2.05-1.32-3.69-2.97-3.69zm0-1.77c-2.75,0-4.96,2.06-4.96,4.62v5.79c0,2.56,2.21,4.62,4.96,4.62s4.96-2.06,4.96-4.62v-5.79c0-2.56-2.21-4.62-4.96-4.62z",
    fillRule: "evenodd",
    stroke: "#db161b",
    strokeWidth: 0.33028123,
    fill: "#fff"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M129.81,107.95c-1.65,0-2.98,1.65-2.98,3.7v0.96c0,2.05,1.33,3.7,2.98,3.7s2.97-1.65,2.97-3.7v-0.96c0-2.05-1.32-3.7-2.97-3.7zm0-1.76c-2.75,0-4.96,2.06-4.96,4.62v2.65c0,2.56,2.21,4.62,4.96,4.62,2.74,0,4.96-2.06,4.96-4.62v-2.65c0-2.56-2.22-4.62-4.96-4.62z",
    fillRule: "evenodd",
    stroke: "#db161b",
    strokeWidth: 0.33028123,
    fill: "#fff"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M117.91,105.51c-2.97,0-5.35,1.84-5.35,4.13v4.58c0,2.29,2.38,4.13,5.35,4.13s5.35-1.84,5.35-4.13v-4.58c0-2.29-2.38-4.13-5.35-4.13zm0-1.98c-4.94,0-8.92,2.31-8.92,5.17v6.47c0,2.86,3.98,5.16,8.92,5.16s8.92-2.3,8.92-5.16v-6.47c0-2.86-3.98-5.17-8.92-5.17z",
    fillRule: "evenodd",
    stroke: "#db161b",
    strokeWidth: 0.33028102,
    fill: "#fff"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M182.36,106.39c-2.97,0-5.36,1.85-5.36,4.14v4.58c0,2.29,2.39,4.13,5.36,4.13,2.96,0,5.35-1.84,5.35-4.13v-4.58c0-2.29-2.39-4.14-5.35-4.14zm0-1.97c-4.95,0-8.93,2.3-8.93,5.16v6.47c0,2.86,3.98,5.16,8.93,5.16,4.94,0,8.92-2.3,8.92-5.16v-6.47c0-2.86-3.98-5.16-8.92-5.16z",
    fillRule: "evenodd",
    stroke: "#db161b",
    strokeWidth: 0.33028102,
    fill: "#fff"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    rx: 0.64577,
    ry: 0.93811,
    height: 5.3042,
    width: 11.898,
    stroke: "#db161b",
    y: 109.72,
    x: 165.5,
    strokeWidth: 0.33028,
    fill: "#fff"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    rx: 0.3767,
    ry: 1.2508,
    height: 7.0722,
    width: 6.9406,
    stroke: "#db161b",
    y: 108.84,
    x: 154.6,
    strokeWidth: 0.33028,
    fill: "#fff"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    rx: 0.3767,
    ry: 1.2508,
    height: 7.0722,
    width: 6.9406,
    stroke: "#db161b",
    y: 108.84,
    x: 121.88,
    strokeWidth: 0.33028,
    fill: "#fff"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    rx: 0.7534,
    ry: 1.5635,
    height: 8.8403,
    width: 13.881,
    stroke: "#db161b",
    y: 107.95,
    x: 100.06,
    strokeWidth: 0.33028,
    fill: "#fff"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    rx: 0.69959,
    ry: 1.5635,
    height: 8.8403,
    width: 12.89,
    stroke: "#db161b",
    y: 108.84,
    x: 186.32,
    strokeWidth: 0.33028,
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOm);
export default __webpack_public_path__ + "static/media/om.ce7832698163e15c9f1ba01857184818.svg";
export { ForwardRef as ReactComponent };